
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME
// GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME


const GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME= createAsyncThunk(
  "getAllStakeNowSectionsWithCreatorBySectionName/getAllStakeNowSectionsWithCreatorBySectionName",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllStakeNowSectionsWithCreatorBySectionNameSlice = createSlice({
  name: "getAllStakeNowSectionsWithCreatorBySectionNameSlice",
  initialState: {
    getAllStakeNowSectionsWithCreatorBySectionName: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllStakeNowSectionsWithCreatorBySectionName: (state) => {
        state.getAllStakeNowSectionsWithCreatorBySectionName.loading = false
        state.getAllStakeNowSectionsWithCreatorBySectionName.error = false
        state.getAllStakeNowSectionsWithCreatorBySectionName.data = []
        state.getAllStakeNowSectionsWithCreatorBySectionName.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME.fulfilled, (state, action) => {
      state.getAllStakeNowSectionsWithCreatorBySectionName = {
        ...state.getAllStakeNowSectionsWithCreatorBySectionName,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME.pending, (state, action) => {
      state.getAllStakeNowSectionsWithCreatorBySectionName = {
        ...state.getAllStakeNowSectionsWithCreatorBySectionName,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME.rejected, (state, action) => {
      state.getAllStakeNowSectionsWithCreatorBySectionName = {
        ...state.getAllStakeNowSectionsWithCreatorBySectionName,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllStakeNowSectionsWithCreatorBySectionNameAction = {
    GETALLSTAKENOWSECTIONSWITHCREATORBYSECTIONNAME,
};

export { getAllStakeNowSectionsWithCreatorBySectionNameAction };
export default getAllStakeNowSectionsWithCreatorBySectionNameSlice.reducer;
export const {setInitialStateOfgetAllStakeNowSectionsWithCreatorBySectionName} = getAllStakeNowSectionsWithCreatorBySectionNameSlice.actions
